import { loadFromLocalStorage, LOCAL_STORAGE_KEYS, saveToLocalStorage } from '../../utils/local_storage';

const itemIdsAlreadyDisplayed = () => {
  return loadFromLocalStorage(LOCAL_STORAGE_KEYS.NEW_FEATURE_DISPLAY_ITEMS) || [];
};

export const newFeatureItemsToDisplay = (displayNewFeatureItems) => {
  const alreadyDisplayed = itemIdsAlreadyDisplayed();
  const itemsToDisplay = displayNewFeatureItems
    .sort((a, b) => {
      return a.rank - b.rank;
    })
    .filter((item) => !alreadyDisplayed.includes(item.id));

  return itemsToDisplay;
};

export const markItemAsDisplayed = (itemId) => {
  const itemIds = itemIdsAlreadyDisplayed();
  if (!itemIds.includes(itemId)) {
    itemIds.push(itemId);
    saveToLocalStorage(LOCAL_STORAGE_KEYS.NEW_FEATURE_DISPLAY_ITEMS, itemIds);
  }
};



// WEBPACK FOOTER //
// ./src/components/feature_tour/utils.jsx